import { UserActionTypes } from './constants';

export const updateUserBasicInfo = (basicInfo) => ({
  type: UserActionTypes.UPDATE_USER_BASIC_INFO,
  payload: basicInfo
});
